import React, { useState, useEffect } from 'react';

const ContactNumber = () => {
  const [contactNumbers, setContactNumbers] = useState({
    student: '',
    client: '',
    lawyer: '',
    official: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Base API URL - replace with your actual API endpoint
  const API_BASE_URL = 'https://admindashboard.clns.in/api/dashboard/phone-numbers-helpline/';

  // Fetch contact numbers on component mount
  useEffect(() => {
    fetchContactNumbers();
  }, []);

  // GET API call to fetch contact numbers
  const fetchContactNumbers = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await fetch(API_BASE_URL);
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log(data)
      
      // Update state with fetched data
      setContactNumbers({
        student: data.student_phone_number || '',
        client: data.client_phone_number || '',
        lawyer: data.advocate_phone_number || '',
        official: data.official_phone_number || ''
      });
    } catch (err) {
      setError('Failed to load contact numbers. Please try again later.');
      console.error('Error fetching contact numbers:', err);
    } finally {
      setIsLoading(false);
    }
  };

  // POST API call to save contact numbers
  const saveContactNumbers = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await fetch(API_BASE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          student_phone_number: contactNumbers.student,
          client_phone_number: contactNumbers.client,
          advocate_phone_number: contactNumbers.lawyer,
          official_phone_number: contactNumbers.official
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const data = await response.json();
      alert('Contact numbers saved successfully!');
      console.log('Save response:', data);
    } catch (err) {
      setError('Failed to save contact numbers. Please try again later.');
      console.error('Error saving contact numbers:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setContactNumbers({
      ...contactNumbers,
      [field]: value
    });
  };

  const handleReset = () => {
    setContactNumbers({
      student: '',
      client: '',
      lawyer: '',
      official: ''
    });
  };

  return (
    <div style={{
      fontFamily: 'Arial, sans-serif',
      maxWidth: '800px',
      margin: '0 auto',
      padding: '20px',
      boxSizing: 'border-box'
    }}>
      {isLoading && (
        <div style={{ textAlign: 'center', padding: '10px', color: '#1a73e8' }}>
          Loading...
        </div>
      )}
      
      {error && (
        <div style={{ 
          textAlign: 'center', 
          padding: '10px', 
          color: 'white', 
          backgroundColor: '#d32f2f',
          borderRadius: '4px',
          marginBottom: '15px'
        }}>
          {error}
        </div>
      )}
      
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px'
      }}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{
            display: 'block',
            color: '#1a73e8',
            fontWeight: 'bold',
            marginBottom: '8px'
          }}>
            Student Helpline
          </label>
          <input
            type="text"
            value={contactNumbers.student}
            onChange={(e) => handleInputChange('student', e.target.value)}
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '12px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '16px',
              boxSizing: 'border-box'
            }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{
            display: 'block',
            color: '#1a73e8',
            fontWeight: 'bold',
            marginBottom: '8px'
          }}>
            Client Helpline
          </label>
          <input
            type="text"
            value={contactNumbers.client}
            onChange={(e) => handleInputChange('client', e.target.value)}
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '12px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '16px',
              boxSizing: 'border-box'
            }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{
            display: 'block',
            color: '#1a73e8',
            fontWeight: 'bold',
            marginBottom: '8px'
          }}>
            Lawyer Helpline
          </label>
          <input
            type="text"
            value={contactNumbers.lawyer}
            onChange={(e) => handleInputChange('lawyer', e.target.value)}
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '12px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '16px',
              boxSizing: 'border-box'
            }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{
            display: 'block',
            color: '#1a73e8',
            fontWeight: 'bold',
            marginBottom: '8px'
          }}>
            Official Helpline
          </label>
          <input
            type="text"
            value={contactNumbers.official}
            onChange={(e) => handleInputChange('official', e.target.value)}
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '12px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '16px',
              boxSizing: 'border-box'
            }}
          />
        </div>
      </div>

      <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '15px'
      }}>
        <button
          onClick={handleReset}
          disabled={isLoading}
          style={{
            padding: '12px 24px',
            border: '1px solid #e0e0e0',
            borderRadius: '4px',
            backgroundColor: 'white',
            color: '#333',
            fontSize: '16px',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            opacity: isLoading ? 0.7 : 1
          }}
        >
          Reset
        </button>
        <button
          onClick={saveContactNumbers}
          disabled={isLoading}
          style={{
            padding: '12px 24px',
            border: 'none',
            borderRadius: '4px',
            backgroundColor: '#1a73e8',
            color: 'white',
            fontSize: '16px',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            opacity: isLoading ? 0.7 : 1
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default ContactNumber;